/*
 *   Copyright (c) 2021 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { User, Credentials } from '../../models/users/user.interface';
import { RegisterService } from '../register/register.service';
import { BehaviorSubject } from 'rxjs';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { RouteAddressService } from '../route-address/route-address.service';
import { ViewImagesComponent } from '../../shared-components/view-images/view-images.component';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class UserService {
  userDetails = new BehaviorSubject<any>({});
  static user_url = environment.config.user_url;
  public businessUnit: any;
  public file: any;
  public currentBusinessUnitId: any;
  public currentBusinessUnit = new BehaviorSubject<any>('');
  public currentBusinessUnitOb = this.currentBusinessUnit.asObservable();
  public BusinessUnitsBS = new BehaviorSubject([]);
  public companyId = new BehaviorSubject('');
  userCompany = '';
  public userProfileImage: any = '';
  public userDisplayName = '';
  public companyLogo;
  public BusinessUnitsOB = this.BusinessUnitsBS.asObservable();
  public businessUnitsDetail;
  public currentBusinessUnitDetail;
  public isEvidenceBS = new BehaviorSubject<boolean>(false);
  public isEvidenceOB = this.isEvidenceBS.asObservable();
  public businessUnitDefaultIcon =
    environment.config.BusinessUnitsicons.defaultBusinessUnitImage;
  public businessUserDefaultIcon = environment.config.BusinessUnitsicons.person;
  public currentVehicleBusinessUnit = new BehaviorSubject<any>('');
  public currentAttendanceBusinessUnit = new BehaviorSubject<any>('');
  public isVehicleBUChanged = new BehaviorSubject<boolean>(false);
  public isAttendanceBUChanged = new BehaviorSubject<boolean>(false);
  public businessUnitList = new BehaviorSubject([]);
  public currentBusinessUnitDetailBS = new BehaviorSubject<any>({});
  public currentBusinessUnitDetailOb = this.currentBusinessUnitDetailBS.asObservable();
  public isFeatureDefaultTab: boolean;
  public bulkUploadLabelKey = { label: '', key: '' };
  public currentUserId;
  public selectedBusinessUnitData;
  public slotWeekArray = [];
  public slotWeekMainArray = [];
  public selectedSalesPersons = [];
  public isArrayChange = false;
  public calendarFilterChange = false;
  public isMonthToWeekView = false;
  public actualDateSelected;
  // public selectedCalendarDate = undefined;
  public calendarDate: any;
  constructor(
    private http: HttpClient,
    private registerService: RegisterService,
    public dialog: MatDialog,
    public routeAddressService: RouteAddressService,
    public router: Router
  ) { }

  getUser(credentials: Credentials) {
    return this.http.post<User>(UserService.user_url.url, credentials);
  }
  getImageURL(path: string, isDefault?) {
    if (isDefault) {
      return path;
    } else {
      if (path) {
        if (path.slice(0, 4) === 'http') {
          return path;
        } else {
          return this.routeAddressService.serverPath + path;
        }
      }
    }
  }
  selectedBusinessUnit(unit) {
    this.currentBusinessUnitId = unit;
    // tslint:disable-next-line:prefer-for-of
    const businessUnitIndex = this.businessUnitsDetail.findIndex(eachUnit => unit === eachUnit.businessUnit._id);
    if (businessUnitIndex > -1) {
      this.currentBusinessUnitDetail = this.businessUnitsDetail[businessUnitIndex].businessUnit;
      if (this.currentBusinessUnitDetail) {
        localStorage.setItem('isEvidence', this.currentBusinessUnitDetail.settings.features.isEvidence);
        localStorage.setItem('isInventory', this.currentBusinessUnitDetail.settings.features.isInventories);
        localStorage.setItem('isExpiry', this.currentBusinessUnitDetail.settings.features.isExpiry);
        localStorage.setItem('isOrder', this.currentBusinessUnitDetail.settings.features.isOrders);
        localStorage.setItem('isOffer', this.currentBusinessUnitDetail.settings.features.isOffers);
        localStorage.setItem('isAttendance', this.currentBusinessUnitDetail.settings.features.isAttendance);
        localStorage.setItem('isVehicle', this.currentBusinessUnitDetail.settings.features.isVehicle);
        localStorage.setItem('isContact', this.currentBusinessUnitDetail.settings.features.isContacts);
        localStorage.setItem('isReport', this.currentBusinessUnitDetail.settings.features.isReports);
        localStorage.setItem('isQuarantine', this.currentBusinessUnitDetail.settings.features.isQuarantine);
        localStorage.setItem('isTracker', this.currentBusinessUnitDetail.settings.features.isTracker);
        localStorage.setItem('isElection', this.currentBusinessUnitDetail.settings.features.isElection);
        localStorage.setItem('isAppointment', this.currentBusinessUnitDetail.settings.features.isAppointment);
        this.currentBusinessUnitDetailBS.next(this.currentBusinessUnitDetail);
        localStorage.setItem('businessUnits', JSON.stringify(this.businessUnitsDetail));
        this.currentBusinessUnit.next(this.currentBusinessUnitId);
      }
    }
    // });
  }
  getBusinessUnit() {
    return this.currentBusinessUnitId;
  }

  replaceImage(imageArray, replacingImage) {
    if (imageArray.length > 0) {
      const img = 'images';
      return imageArray[0].originalImageURL;
    } else {
      const img = 'images';
      return replacingImage;
    }
  }
  // for viewing images in a seperate dialog

  viewProductImages(images, isList?, allImags?, index?, imageURL?) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = false;
    dialogConfig.hasBackdrop = true;
    if (window.innerWidth > 960) {
      dialogConfig.maxWidth = '70vw';
      dialogConfig.width = '70vw';
      dialogConfig.maxHeight = '90vh';
      dialogConfig.height = '90vh';
      dialogConfig.position = {
        top: '5vh',
        left: '15vw'
      };
    } else {
      dialogConfig.maxWidth = '90vw';
      dialogConfig.width = '90vw';
      dialogConfig.maxHeight = '40vh';
      dialogConfig.height = '40vh';
      dialogConfig.position = {
        top: '30vh',
        left: '5vw'
      };
    }
    dialogConfig.panelClass = 'nvc-override';
    dialogConfig.data = {
      images: images,
      allImages: allImags,
      imageIndex: index,
      isListDisplay: isList,
      imageURL
    };
    console.log(dialogConfig.data);
    this.dialog.open(ViewImagesComponent, dialogConfig);
  }
  getCurrentBusinessUnitData(businessUnitId) {
    return this.http.get(environment.config.prodServerUrl + environment.config.companyUrl.updateBusUnits + businessUnitId);
  }
  logout() {
    return this.http.get<any>(environment.config.prodServerUrl + environment.config.user.signout);
  }
  redirectToSettingFeatures() {
    this.isFeatureDefaultTab = true;
    this.router.navigateByUrl('/homePage/setting');
  }

  // check bulk-upload-data-service for label and key
  redirectToBulkUpload(label, key) {
    this.bulkUploadLabelKey.label = label;
    this.bulkUploadLabelKey.key = key;
    this.router.navigateByUrl('/bulkupload');
  }
  getUserData() {
    return this.http.get(environment.config.prodServerUrl + environment.config.user.features);
  }
}
